import createTypography from "@mui/material/styles/createTypography";
import { themePalette } from "./palette";

export const themeTypography = () =>
  createTypography(themePalette, {
    fontFamily: '"Roboto", Arial, sans-serif',
    htmlFontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    button: {
      textTransform: "capitalize",
      // fontSize: "0.75rem"
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.57
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      lineHeight: 1.66
    },
    caption: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.66
    },
    h1: {
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: 1.21
    },
    h2: {
      fontWeight: 600,
      fontSize: "2rem",
      lineHeight: 1.27
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.625rem",
      lineHeight: 1.33
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.375rem",
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.57
    }
  });
